module.exports = __webpack_public_path__ + "img/208.problem_urinals.07a3a353.svg";